import { type Location, useLocation } from "react-router-dom";

type BackgroundLocation = Location & {
  state?: Location["state"] & { background?: Location };
};

export const getBackgroundLocation = (location: BackgroundLocation) => {
  const background = location.state?.background;
  return background ?? location;
};

export const useBackgroundLocation = (): Location => {
  const location = useLocation();
  return getBackgroundLocation(location as BackgroundLocation);
};
